const renderRawHtml = __html => ({ dangerouslySetInnerHTML: { __html } })

export default renderRawHtml
